/* eslint-disable react-hooks/exhaustive-deps */

import React, { useMemo } from 'react'
import { Box } from '@mui/material'
import BarChartRanking from './BarChartRanking'
import CountryTick from 'components/common/CountryTick/CountryTick'
import * as Flags from 'country-flag-icons/react/3x2'
import { BarChartGlobalData } from 'types'
import { scaleLinear } from 'd3-scale'
import _ from 'lodash'
import { useAppSelector } from 'hooks'
import { inputFilter } from 'store/AIMetricOT/reducerSlice'
import { getCountryNameFromCountryLongCode } from 'utils'

interface IReportBarChart {
  currentYear: number
  // data: any[] | undefined
  data: BarChartGlobalData
}

const ReportBarChart: React.FC<IReportBarChart> = ({ currentYear, data }) => {
  const countryData = useAppSelector(({ vibrancy }) => vibrancy.countryData)
  const currentFilter = useAppSelector(inputFilter)
  const { country: currentCountry } = currentFilter
  const activeCountryName = getCountryNameFromCountryLongCode(countryData, currentCountry)
  const renderData = useMemo(() => {
    const list = data.slice(0, 10)
    const findInData = data?.find((ele: any) => ele?.countryLongCode === currentCountry)
    const findInList = list?.findIndex((ele: any) => ele?.countryLongCode === currentCountry)
    if (findInList < 0 && findInData) {
      list.push(findInData)
    }
    return list
  }, [data])
  // data = data.slice(0, 10)
  const renderCustomAxisTick = ({ payload, y }: { payload: { value: string }; y: number }) => {
    return (
      <>
        {data && (
          <CountryTick
            countryCode={payload.value as keyof typeof Flags}
            id={data?.find((el) => el.name === payload.value)?.id ?? 0}
            countryName={data?.find((el) => el.name === payload.value)?.countryName ?? ''}
            position={{ y }}
            isNotFlags={true}
            activeCountryName={activeCountryName}
          />
        )}
      </>
    )
  }
  const renderTick = (dataParam: BarChartGlobalData) =>
    scaleLinear()
      .domain([0, _.max(dataParam.map((el) => el.score)) ?? 0])
      .ticks()
      .filter((el) => el % 10 === 0)

  return (
    <>
      <span style={{ fontFamily: 'CircularStdMedium' }}>Top Ranking {currentYear}</span>
      <Box sx={{ width: '100%' }}>
        <BarChartRanking
          data={renderData}
          isStackedBarChart
          xAxisTicks={renderTick(renderData)}
          yAxisTickRenderFunc={renderCustomAxisTick}
        />
      </Box>
      <span
        style={{
          fontSize: '11px',
          fontFamily: 'CircularStdMedium',
          fontWeight: 500,
          position: 'relative',
          marginLeft: '65px',
        }}
      >
        Total Weighted Index Score
      </span>
    </>
  )
}

export default ReportBarChart
